import { useEffect, useRef, useState } from "react";
import { Stores, useGlobalState } from "react-migration/lib/persistence/state";
import { useQuery } from "@apollo/client";
import SITE_OVERVIEW from "react-migration/domains/sites/apollo/li-api/queries/siteOverview.gql";
import { routedClient } from "react-migration/lib/persistence/apollo";
import { Theme, DeprecatedTooltip } from "@landtechnologies/components";

export const SiteName = () => {
  const [{ siteCardId }] = useGlobalState(Stores.site);
  const titleRef = useRef<HTMLDivElement>(null);
  const [isTooltipVisible, setTooltipVisibility] = useState(false);

  const { loading, data } = useQuery(SITE_OVERVIEW, {
    variables: { _id: siteCardId },
    client: routedClient,
  });

  const titleTemplate = (
    <div
      className="atlas-mb-2 atlas-mt-1 atlas-text-sm atlas-leading-5 atlas-line-clamp-2 atlas-min-h-[20px]"
      data-testid="site-name"
      ref={titleRef}
    >
      {!loading && data?.siteOverview?.title}
    </div>
  );

  useEffect(() => {
    const { current: siteTitleElement } = titleRef;
    if (!siteTitleElement) {
      return;
    }
    const isOverflow = siteTitleElement.clientHeight < siteTitleElement.scrollHeight;
    if (isOverflow !== isTooltipVisible) {
      setTooltipVisibility(isOverflow);
    }
  }, [titleRef, data]);

  return isTooltipVisible ? (
    <DeprecatedTooltip description={data?.siteOverview?.title} theme={Theme.Dark} placement="top">
      {titleTemplate}
    </DeprecatedTooltip>
  ) : (
    titleTemplate
  );
};
